(function(window, angular) {
  "use strict";
  var m = angular.module("vvCommon");  

  m.controller('FooterCtrl', function($scope, vv, vvCommon, vvRegister) {
    var region = vv.getVvMetaData('region');
    $scope.contactUrl = vvCommon.getContactUrl(region);
    $scope.termsOfServiceUrl = vvCommon.getTermsOfService(region);

    $scope.region = region;
    if (region == "cn"){
      $http.post('http://cn.biwhy.cn/api/host/icp').success(function(data){
        $scope.icpInfo = data["icp_name"];
      });
    }

    $scope.deregister = function() {
      vvRegister.deregister();
    };
  });
})(window, window.angular);

